import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap";

import { fetchMachines, addMachine, resetMachines } from "../actions/machines";
import MachineList from "../components/MachineList";
import ErrorMessage from "../components/ErrorMessage";
import MachinesCashSummary from "../components/MachinesCashSummary";
import { fetchBateriesCSV } from "../actions/matrixs";
import { fetchSNCSV } from "../actions/matrixs";

import "../styles/MachinesAdminView.css";

class MachinesView extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      summaryOpen: false,
      showAddModal: false,
      isSubmitting: false,
      fakeProgress: 0,
    };

    this.toggle = this.toggle.bind(this);
    this.handleDownloadBateriesCSV = this.handleDownloadBateriesCSV.bind(this);
    this.handleDownloadSNCSV = this.handleDownloadSNCSV.bind(this);
  }

  toggle() {
    this.setState({
      summaryOpen: !this.state.summaryOpen,
    });
  }

  handleDownloadBateriesCSV() {
    const { fetchBateriesCSV } = this.props;

    fetchBateriesCSV();
  }

  handleDownloadSNCSV() {
    const { fetchSNCSV } = this.props;

    fetchSNCSV();
  }

  componentDidMount() {
    const { fetchMachines, resetMachines } = this.props;
    resetMachines();
    fetchMachines();
    this.startFakeProgress();
  }

  componentDidUpdate(prevProps) {
    // Detect transition from empty to loaded machines
    if (!prevProps.machines?.length && this.props.machines?.length) {
      this.finishFakeProgress();
    }
  }

  startFakeProgress() {
    this.setState({ fakeProgress: 0 });

    if (this.fakeProgressInterval) {
      clearInterval(this.fakeProgressInterval);
    }

    // Increase progress gradually up to 80% over ~5s
    this.fakeProgressInterval = setInterval(() => {
      this.setState((prev) => {
        if (prev.fakeProgress >= 80) {
          clearInterval(this.fakeProgressInterval);
          return prev;
        }
        return { fakeProgress: prev.fakeProgress + 1 };
      });
    }, 31); // ~80 steps * 62ms = 4960ms ≈ 5s
  }

  finishFakeProgress() {
    if (this.fakeProgressInterval) clearInterval(this.fakeProgressInterval);

    this.setState({ fakeProgress: 100 });

    // Optional: fade-out or reset after a second
    setTimeout(() => this.setState({ fakeProgress: 0 }), 1000);
  }

  componentWillUnmount() {
    if (this.fakeProgressInterval) {
      clearInterval(this.fakeProgressInterval);
    }
  }

  openAddModal = () => this.setState({ showAddModal: true });
  closeAddModal = () => this.setState({ showAddModal: false });

  handleAddMachine = async () => {
    const { addMachine, fullname, fetchMachines } = this.props;

    this.setState({ isSubmitting: true });

    try {
      const response = await addMachine({ Executor: fullname });
      if (response && !response.error) {
        this.setState({ showAddModal: false });
        fetchMachines(); // Optional: refresh list
      } else {
        alert("Error al añadir la máquina.");
      }
    } catch (error) {
      console.error(error);
      alert("Error al añadir la máquina.");
    }

    this.setState({ isSubmitting: false });
  };

  render() {
    const { machines, error, role, type, loading } = this.props;

    if (loading || !machines) {
      const progress = this.state.fakeProgress;
      return (
        <div className="kpi-loading min-vh-100 d-flex flex-column align-items-center justify-content-center">
          <img
            className="kpi-loading-logo"
            src="/images/logo_blue.png"
            alt="Logo"
            height={56}
          />
          <div
            className="kpi-progress"
            role="progressbar"
            aria-valuemin={0}
            aria-valuemax={100}
            aria-valuenow={progress}
          >
            <div
              className="kpi-progress-fill"
              style={{
                width: `${progress}%`,
                transition: "width 0.3s ease-out",
              }}
            />
          </div>
          <div className="kpi-progress-text">{progress}%</div>
        </div>
      );
    }

    if (error) return <ErrorMessage message={error.message} />;

    return (
      <div className="machines-admin-view">
        {/* Header */}
        <div className="mach-admin-header">
          <div className="header-content">
            <div className="header-text">
              <h1>
                <i className="fas fa-desktop mr-3"></i>
                <span className="text-vw-dark mr-1">Parque de</span>
                <span className="text-vw-light">Kioscos</span>
              </h1>
            </div>
            {role === "ADMIN" && (type === "MASTER" || type === "PRODUCCION") && (
              <div className="header-actions">
                <button
                  type="button"
                  className="mach-admin-btn primary"
                  onClick={this.openAddModal}
                >
                  <i className="fas fa-plus"></i>
                  <span>Nueva</span>
                </button>
                <button
                  type="button"
                  className="mach-admin-btn secondary"
                  onClick={(e) => this.toggle()}
                >
                  <i className="fas fa-expand"></i>
                  <span>Ver cash parque</span>
                </button>
                <button
                  className="mach-admin-btn success"
                  onClick={this.handleDownloadBateriesCSV}
                >
                  <i className="fas fa-file-excel"></i>
                  <span>Descargar Baterías</span>
                </button>
                <button
                  className="mach-admin-btn warning"
                  onClick={this.handleDownloadSNCSV}
                >
                  <i className="fas fa-file-excel"></i>
                  <span>Descargar Listado SN</span>
                </button>
              </div>
            )}
          </div>
        </div>

        {this.state.summaryOpen && (
          <div>
            <MachinesCashSummary machines={machines} /> <br />
            <hr />
            <br />
          </div>
        )}

        <MachineList machines={machines} />

        <Modal
          isOpen={this.state.showAddModal}
          toggle={this.closeAddModal}
          centered
        >
          <ModalHeader toggle={this.closeAddModal}>
            Nueva Máquina - Confirmación
          </ModalHeader>
          <ModalBody>
            Vas a añadir una máquina nueva con parámetros predefinidos.
            <br />
            <br />
            También se añadirá un contrato nuevo para esta máquina a nombre de{" "}
            <strong>VACWAY TECH</strong>.<br />
            <br />
            Más tarde puedes editar esos documentos para modificar sus
            parámetros.
          </ModalBody>
          <ModalFooter>
            <Button color="secondary" onClick={this.closeAddModal}>
              Cancelar
            </Button>
            <Button
              color="primary"
              onClick={this.handleAddMachine}
              disabled={this.state.isSubmitting}
            >
              {this.state.isSubmitting ? "Añadiendo..." : "Añadir"}
            </Button>
          </ModalFooter>
        </Modal>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  machines: state.machines.machines,
  loading: state.machines.loading,
  error: state.machines.error,
  role: state.auth.role,
  type: state.auth.type,
  fullname: state.auth.fullname,
});

const mapDispatchToProps = (dispatch) => ({
  fetchMachines: bindActionCreators(fetchMachines, dispatch),
  resetMachines: bindActionCreators(resetMachines, dispatch),
  fetchBateriesCSV: bindActionCreators(fetchBateriesCSV, dispatch),
  fetchSNCSV: bindActionCreators(fetchSNCSV, dispatch),
  addMachine: bindActionCreators(addMachine, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(MachinesView);
